// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8914":"d47e4f3ff15ec2c4","48846":"6438dbb375600f1b","80082":"e8dec7efcdc6dc08"}[chunkId] + ".css";
};